import { i18n } from "discourse-i18n";

export default <template>
  <p class="user-profile-hidden">{{i18n "user.profile_hidden"}}</p>
</template>
